
  <div class="center" (click)="onMouseClick($event)">
    <div *ngIf="(hasFailedSolution)" class="half-width">
      <div class="errorMsg" *ngFor="let solResults of results">
          <span *ngIf="(solResults.fail)"> {{solResults.solutionID}} : {{ solResults.messageStr }}</span>
      </div>
    </div>
    <div class="half-width">
      <div class="tabs" [ngClass]="'selected'">
        <span>Standard ASTM Report </span>
      </div>
    </div>

    <div class="next-button-content">
      <button class="button-content ripple" (click)="prepareRptList()">
          <span class='space'>Generate</span>
      </button>
    </div>
  </div>

  <div class="d-flex justify-content-center cover-spin" *ngIf="loading">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>




